module.exports = __webpack_public_path__ + "img/system25-details.c6641dad.png";